"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MinSqErrorMaxItemStopper = exports.MinErrorMaxItemStopper = exports.MinErrorStopper = exports.MaxItemStopper = exports.Stopper = void 0;
const irt_1 = require("./irt");
var tf = require("@tensorflow/tfjs-core");
var distance = require('euclidean-distance');
class Stopper {
}
exports.Stopper = Stopper;
class MaxItemStopper extends Stopper {
    /**
     * This class implements a stopping criterion which stops the test when a given number of items have
     * been asked. If used alone, it leads to fixed length tests
     * @param maxIters : maximal number of items to be asked in the test
     */
    constructor(maxIters) {
        super();
        this._maxIters = maxIters;
    }
    /**
     *
     * @param administeredItems : items that have already been asked in the test
     * @returns a boolean which indicates whether the stopping criterion has been reached or not
     */
    stop(administeredItems) {
        if (!administeredItems) {
            throw new Error();
        }
        var nbIters = administeredItems.length;
        if (nbIters > this._maxIters) {
            throw new Error("More items than allowed were administered");
        }
        return nbIters == this._maxIters;
    }
}
exports.MaxItemStopper = MaxItemStopper;
class MinErrorStopper extends Stopper {
    /**
     * This class implements a stopping criterion which stops the test when the standard error of estimation
     * on the theta parameter in each of the dimension is less than a given threshold.
     * @param minError : threshold under which the estimation is considered precise enough.
     */
    constructor(minError) {
        super();
        this._minError = minError;
    }
    /**
     *
     * @param administeredItems : list of items that have already been asked in the test
     * @param currentFisherMat : current fisher information matrix after all items of AdministeredItems
     * have been asked
     * @returns a boolean which indicates whether the stopping criterion has been reached or not
     */
    stop(administeredItems, currentFisherMat) {
        if (!administeredItems) {
            throw new Error();
        }
        const allInferior = (arr) => arr.every((v) => v < this._minError);
        return allInferior((0, irt_1.see)(currentFisherMat));
    }
}
exports.MinErrorStopper = MinErrorStopper;
class MinErrorMaxItemStopper extends Stopper {
    constructor(minError, maxIters) {
        super();
        this._minError = minError;
        this._maxIters = maxIters;
    }
    /**
     *
     * @param administeredItems : list of items that have already been asked in the test
     * @param currentFisherMat : current fisher information matrix after all items of AdministeredItems
     * have been asked
     * @returns a boolean which indicates whether the stopping criterion has been reached or not
     */
    stop(administeredItems, currentFisherMat) {
        if (!administeredItems) {
            throw new Error();
        }
        var nbIters = administeredItems.length;
        if (nbIters > this._maxIters) {
            throw new Error("More items than allowed were administered");
        }
        const allInferior = (arr) => arr.every((v) => v < this._minError);
        return allInferior((0, irt_1.see)(currentFisherMat)) || nbIters == this._maxIters;
    }
}
exports.MinErrorMaxItemStopper = MinErrorMaxItemStopper;
class MinSqErrorMaxItemStopper extends Stopper {
    constructor(minError, maxIters, selectedItem) {
        super();
        this._minError = minError;
        this._maxIters = maxIters;
        this._selectedItem = selectedItem;
    }
    /**
     *
     * @param administeredItems : list of items that have already been asked in the test
     * @param currentFisherMat : current fisher information matrix after all items of AdministeredItems
     * have been asked
     * @returns a boolean which indicates whether the stopping criterion has been reached or not
     */
    stop(administeredItems, estimator, difficulties, discriminations, actSequence, thetaEstimation) {
        if (!administeredItems) {
            throw new Error();
        }
        var nbIters = administeredItems.length;
        if (nbIters > this._maxIters) {
            throw new Error("More items than allowed were administered");
        }
        // Cas réponse juste
        actSequence["act"].push(this._selectedItem);
        actSequence["res"].push(1);
        actSequence["weight"].push(1);
        var new_theta_1 = estimator.estimate(discriminations, difficulties, actSequence["act"], actSequence["res"], tf.tensor(thetaEstimation), actSequence["weight"]);
        actSequence["res"].pop();
        //Cas réponse fausse 
        actSequence["res"].push(0);
        var new_theta_2 = estimator.estimate(discriminations, difficulties, actSequence["act"], actSequence["res"], tf.tensor(thetaEstimation), actSequence["weight"]);
        actSequence["act"].pop();
        actSequence["res"].pop();
        actSequence["weight"].pop();
        var d1 = distance(thetaEstimation, new_theta_1);
        var d2 = distance(thetaEstimation, new_theta_2);
        var zr = new Float32Array(thetaEstimation.length);
        zr.fill(0);
        var d = distance(thetaEstimation, zr);
        //console.log(d1,d2,d)
        return nbIters == this._maxIters || d1 <= this._minError * d || d2 <= this._minError * d;
    }
}
exports.MinSqErrorMaxItemStopper = MinSqErrorMaxItemStopper;
